import RichText, { RichTextContent } from '../../../RichText';
import { Box, useTheme } from '@mui/material';
import LightThemeProvider from '../../../../providers/LightThemeProvider';
import DarkThemeProvider from '../../../../providers/DarkThemeProvider';

type Props = {
  description?: RichTextContent;
  palletMode?: 'light' | 'dark';
  isOpen?: boolean;
  isVirtual?: boolean;
};

const OpenElement = ({ description, palletMode, isOpen }: Props) => {
  const theme = useTheme();
  const ThemeProvider =
    palletMode === 'light' ? LightThemeProvider : DarkThemeProvider;

  const isAlternatePallet = palletMode !== theme.palette.mode;
  return (
    <ThemeProvider>
      <Box
        sx={{
          gridColumn: 1,
          gridRow: 1,
          pointerEvents: isOpen ? 'auto' : 'none',
          opacity: isOpen ? 1 : 0,
          visibility: isOpen ? 'visible' : 'hidden',
          borderTop: `1px solid white`,
          borderTopColor: isAlternatePallet
            ? 'background.default'
            : 'background.paper',
          bgcolor: isAlternatePallet
            ? 'background.default'
            : 'background.paper',
          width: '100%',
          height: '100%',
          transition: theme.transitions.create(['width', 'height'], {
            duration: theme.transitions.duration.shortest,
          }),
        }}
      >
        <Box
          sx={{
            height: { xs: '100%', md: '100%' },
            width: { xs: '100%', md: '100%' },
            p: { xs: 3, md: 4, lg: 7 },
            pb: { md: 0 },
            color: 'text.primary',
            overflow: 'hidden',
            transition: theme.transitions.create(['opacity'], {
              duration: theme.transitions.duration.shortest,
            }),
          }}
        >
          <RichText>{description}</RichText>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default OpenElement;
